// Mirrors backend/src/billing/amount-in-words.ts so the on-screen invoice
// shows the same words the PDF prints.
const ONES = [
  '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
  'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
  'Seventeen', 'Eighteen', 'Nineteen',
];
const TENS = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

function twoDigits(n: number): string {
  if (n < 20) return ONES[n];
  const one = n % 10;
  return one === 0 ? TENS[Math.floor(n / 10)] : `${TENS[Math.floor(n / 10)]} ${ONES[one]}`;
}

function threeDigits(n: number): string {
  const hundred = Math.floor(n / 100);
  const rest = n % 100;
  if (hundred === 0) return twoDigits(rest);
  return rest === 0 ? `${ONES[hundred]} Hundred` : `${ONES[hundred]} Hundred ${twoDigits(rest)}`;
}

// Indian numbering: Crore (1e7) / Lakh (1e5) / Thousand (1e3) / Hundred
export function amountInWordsInr(amount: number): string {
  const n = Math.round(amount);
  if (n === 0) return 'INR Zero Only';
  const crore = Math.floor(n / 1_00_00_000);
  const lakh = Math.floor((n % 1_00_00_000) / 1_00_000);
  const thousand = Math.floor((n % 1_00_000) / 1_000);
  const hundred = n % 1_000;
  const parts: string[] = [];
  if (crore > 0) parts.push(`${threeDigits(crore)} Crore`);
  if (lakh > 0) parts.push(`${threeDigits(lakh)} Lakh`);
  if (thousand > 0) parts.push(`${threeDigits(thousand)} Thousand`);
  if (hundred > 0) parts.push(threeDigits(hundred));
  return `INR ${parts.join(' ')} Only`;
}
